var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOverviewSubscriptionHubOpIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#EE5A00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.3322 16.2651C33.3479 15.1132 29.7877 15.2179 26.594 14.9562C22.9292 14.642 19.0548 13.752 15.39 14.0661C11.8821 14.3803 10.3638 19.1446 14.4999 19.7729C18.3742 20.3488 22.2485 19.7729 26.0705 19.5111C29.4212 19.2493 33.2432 19.4587 36.3322 18.2022C37.2222 17.8881 37.2222 16.6315 36.3322 16.2651Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3322 31.2406C33.3479 30.0888 29.7877 30.1935 26.594 29.9318C22.9292 29.6176 19.0548 28.7276 15.39 29.0417C11.8821 29.3558 10.3638 34.1202 14.4999 34.7485C18.3742 35.3244 22.2485 34.7485 26.0705 34.4867C29.4212 34.2249 33.2432 34.4343 36.3322 33.1778C37.2222 32.8637 37.2222 31.5548 36.3322 31.2406Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6675 25.533C15.6518 26.6848 19.212 26.5801 22.4057 26.8419C26.0705 27.156 29.9449 28.046 33.6097 27.7319C37.1176 27.4178 38.6359 22.6534 34.4998 22.0252C30.6255 21.4493 26.7512 22.0252 22.9292 22.2869C19.5785 22.5487 15.7565 22.3393 12.6675 23.5958C11.7775 23.91 11.7775 25.1665 12.6675 25.533Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverviewSubscriptionHubOpIcon);
export default __webpack_public_path__ + "static/media/overview-subscription-hub-op-icon.8817b52a72a69343d0947e625a43dbac.svg";
export { ForwardRef as ReactComponent };